import { PlacementType } from '../tenant';
export default (placement) => 
// eslint-disable-next-line implicit-arrow-linebreak
placement.type === PlacementType.Modal;
//# sourceMappingURL=isModal.js.map